import { createFeature, createReducer, on } from '@ngrx/store';
import * as HistoryActions from './history.actions';
import { UserHistory } from '../interfaces';

export const initialState: UserHistory[] = [];

export const historyReducer = createReducer(
	initialState,
	on(HistoryActions.addHistory, (state) => {
		return [...state];
	}),
	on(HistoryActions.HistoryLoaded, (state, { payload }) => {
		// remove the entry from state if it already exist and add it to the end of the array, take only latest items from state if lengh is more than 5
		let newState = state.filter((historyItem) => historyItem.search_id !== payload.search_id);
		if (newState.length >= 5) {
			newState = newState.slice(-4);
		}
		return [...newState, payload];
	}),
	on(HistoryActions.resetHistory, (state, { userHistory }) => {
		let newState = [...state, ...userHistory];
		if (newState.length > 5) {
			newState = newState.slice(-5);
		}
		return newState;
	}),
);

export const historyDataFeature = createFeature({
	name: 'historyData',
	reducer: historyReducer,
});
